import { jsx as _jsx } from "react/jsx-runtime";
import { ThorView } from '@aviv-dxp/react-thor';
import { useAuthentication } from '@aviv-unified-frontend/runtime/authentication';
import { useLocale } from '@aviv-unified-frontend/runtime/i18n';
import { useShortBrand } from '@/contexts/brandConfiguration/hooks';
import { LANDING_TYPE, PAGE_CONFIGURATION } from '@/types';
import { APP_ENV } from '@/utils/constants';
import { INITIATIVE } from './constants';
import { addSearchParam, cid, handleWithTrackingHref, parseJwt } from './utils';
const ViewTracker = (data) => {
    const shortBrand = useShortBrand();
    const { state, unsafe_accessToken } = useAuthentication();
    const { locale } = useLocale();
    const isConnected = state === 'authenticated';
    const accessToken = unsafe_accessToken ? parseJwt(unsafe_accessToken) : '';
    const viewProps = {
        av_url_path: typeof window !== 'undefined' ? window.location.pathname : '',
        av_category: 'classified',
        av_platform: 'web',
        av_environment: APP_ENV,
        av_site: shortBrand === 'IMN' ? 'INT' : shortBrand,
        av_language: locale,
        av_user: {
            status: isConnected ? 'logged' : 'unlogged',
            ...(isConnected
                ? { uid: accessToken.avivUserId, cid: cid() }
                : { cid: cid() }),
        },
        ...data,
    };
    return _jsx(ThorView, { viewProps: viewProps });
};
export const FSRBOGenericView = () => {
    return (typeof window !== 'undefined' && (_jsx(ViewTracker, { av_pagetitle: "classified_deposit_landing", av_estate_type_global: "av_6", av_estate_subtype: "9_2", av_initiative: INITIATIVE.FSRBO })));
};
export const FRBOGenericView = () => {
    return (typeof window !== 'undefined' && (_jsx(ViewTracker, { av_pagetitle: "classified_deposit_rent_property_landing", av_estate_type_global: "av_6", av_estate_subtype: "9_2", av_initiative: INITIATIVE.FSRBO })));
};
export const FSBOGenericView = () => {
    return (typeof window !== 'undefined' && (_jsx(ViewTracker, { av_pagetitle: "classified_deposit_sell_property_landing", av_estate_type_global: "av_6", av_estate_subtype: "9_2", av_initiative: INITIATIVE.FSBO })));
};
export const FSRBOFlatView = () => {
    return (typeof window !== 'undefined' && (_jsx(ViewTracker, { av_pagetitle: "classified_deposit_advertise_apartment_landing", av_estate_type_global: "av_2", av_estate_subtype: "1", av_initiative: INITIATIVE.FSRBO })));
};
export const FSRBOCommercialView = () => {
    return (typeof window !== 'undefined' && (_jsx(ViewTracker, { av_pagetitle: "classified_deposit_commercial_properties_landing", av_estate_type_global: "av_13", av_estate_subtype: "12_1", av_initiative: INITIATIVE.FSRBO })));
};
export const FRBOFlatView = () => {
    return (typeof window !== 'undefined' && (_jsx(ViewTracker, { av_pagetitle: "classified_deposit_rent_apartment_landing", av_estate_type_global: "av_2", av_estate_subtype: "2_1", av_initiative: INITIATIVE.FRBO })));
};
export const FRBOHousesView = () => {
    return (typeof window !== 'undefined' && (_jsx(ViewTracker, { av_pagetitle: "classified_deposit_rent_house_landing", av_estate_type_global: "av_5", av_estate_subtype: "4_1", av_initiative: INITIATIVE.FRBO })));
};
export const FSBOPlotView = () => {
    return (typeof window !== 'undefined' && (_jsx(ViewTracker, { av_pagetitle: "classified_deposit_sell_plots_landing", av_estate_type_global: "av_2", av_estate_subtype: "1", av_initiative: INITIATIVE.FSBO })));
};
export const FRBOPlotView = () => {
    return (typeof window !== 'undefined' && (_jsx(ViewTracker, { av_pagetitle: "classified_deposit_rent_plots_landing", av_estate_type_global: "av_9", av_estate_subtype: "8_3", av_initiative: INITIATIVE.FRBO })));
};
export const FSRBODispatchView = () => {
    return (typeof window !== 'undefined' && (_jsx(ViewTracker, { av_pagetitle: "classified_deposit_project", av_initiative: INITIATIVE.FSRBO })));
};
export const FRBOCommercialView = () => {
    return (typeof window !== 'undefined' && (_jsx(ViewTracker, { av_pagetitle: "classified_deposit_rent_commercial_properties_landing", av_estate_type_global: "av_7", av_estate_subtype: "6_8", av_initiative: INITIATIVE.FRBO })));
};
export const trackPushCardRedirection = (e, index) => {
    let medium;
    switch (index) {
        case 1:
            medium = 'classified_deposit_landing_view_prices_on_the_map_price_map';
            break;
        case 2:
            medium =
                'classified_deposit_landing_access_the_service_general_caf_step_1';
            break;
        case 3:
            medium = 'classified_deposit_landing_start_estimation_estimate_landing';
            break;
    }
    if (medium) {
        handleWithTrackingHref(e.element, medium);
    }
};
export const dispatchRedirectionTracking = (pageConfiguration, landingType, url) => {
    switch (landingType) {
        case LANDING_TYPE.flats:
            return pageConfiguration === PAGE_CONFIGURATION.frbo
                ? trackFrboFlatFurtherRedirection(url)
                : trackFlatFurtherRedirection(url);
        case LANDING_TYPE.plots:
            return pageConfiguration === PAGE_CONFIGURATION.frbo
                ? trackFrboPlotFurtherRedirection(url)
                : trackPlotFurtherRedirection(url);
        case LANDING_TYPE.commercial:
            return pageConfiguration === PAGE_CONFIGURATION.frbo
                ? trackFrboCommercialFurtherRedirection(url)
                : trackCommercialFurtherRedirection(url);
        case LANDING_TYPE.houses:
            return pageConfiguration === PAGE_CONFIGURATION.frbo
                ? trackFrboHousesFurtherRedirection(url)
                : trackFlatFurtherRedirection(url);
        case LANDING_TYPE.generic:
            return pageConfiguration === PAGE_CONFIGURATION.frbo
                ? trackFrboGenericFurtherRedirection(url)
                : trackFsboGenericFurtherRedirection(url);
        default:
            return trackFurtherRedirection(url, pageConfiguration === PAGE_CONFIGURATION.frbo ? 'rent' : 'sale');
    }
};
export const trackProRedirection = (url) => addSearchParam(url, 'm', 'classified_deposit_project_project_list_your_dedicated_service_general_caf_step_1');
export const trackFlatFurtherRedirection = (url) => addSearchParam(url, 'm', 'classified_deposit_advertise_apartment_landing_place_an_ad_classified_deposit_property_type');
export const trackPlotFurtherRedirection = (url) => addSearchParam(url, 'm', 'classified_deposit_sell_plots_landing_place_an_ad_classified_deposit_property_type');
export const trackFrboPlotFurtherRedirection = (url) => addSearchParam(url, 'm', 'classified_deposit_rent_plots_landing_place_an_ad_classified_deposit_property_type');
export const trackCommercialFurtherRedirection = (url) => addSearchParam(url, 'm', 'classified_deposit_commercial_properties_landing_place_an_ad_classified_deposit_property_type');
export const trackFrboCommercialFurtherRedirection = (url) => addSearchParam(url, 'm', 'classified_deposit_rent_commercial_properties_landing_place_an_ad_classified_deposit_property_type');
export const trackFrboFlatFurtherRedirection = (url) => addSearchParam(url, 'm', 'classified_deposit_rent_apartment_landing_place_an_ad_classified_deposit_property_type');
export const trackFrboHousesFurtherRedirection = (url) => addSearchParam(url, 'm', 'classified_deposit_rent_house_landing_place_an_ad_classified_deposit_property_type');
export const trackFrboGenericFurtherRedirection = (url) => addSearchParam(url, 'm', 'classified_deposit_rent_property_landing_place_an_ad_classified_deposit_property_type');
export const trackFsboGenericFurtherRedirection = (url) => addSearchParam(url, 'm', 'classified_deposit_sell_property_landing_place_an_ad_classified_deposit_property_type');
export const trackFurtherRedirection = (url, choice) => {
    const medium = choice === 'rent'
        ? 'classified_deposit_project_for_rent_classified_deposit_landing_rent'
        : 'classified_deposit_project_for_sale_classified_deposit_landing_sell';
    return addSearchParam(url, 'm', medium);
};
